export const SUPPORTED_CHAINS=[42]